import {
  NOT_FOUND_IMAGE,
  PAGE_URL,
} from '@/app/components/sections/content-hub/contents';
import type {
  ContentHubEntry,
  ExpertCardItemType,
} from '@/app/components/sections/content-hub/types';

export const parseExpertListItems = (
  category: string,
  entries: ContentHubEntry[] = []
): ExpertCardItemType[] =>
  entries.map((item) => {
    const image =
      item.thumbnailImage &&
      item.thumbnailImage.width &&
      item.thumbnailImage.height
        ? {
            src: item.thumbnailImage.url,
            alt: item.title,
            width: item.thumbnailImage.width,
            height: item.thumbnailImage.height,
          }
        : NOT_FOUND_IMAGE;
    return {
      href: `${PAGE_URL}/${category}/${item.url}`,
      image: {
        ...image,
        rootMargin: '0px 0px -5% 0px',
        aspectRatio: 'calculate',
      },
      date: { startDate: item.beginDate },
      title: item.title,
      description: item.excerpt,
      test: {
        'test-pin': item.pin !== null ? String(item.pin) : undefined,
        'test-tag':
          item.tags && item.tags.length > 0
            ? item.tags.map((o) => o.url).join(',')
            : undefined,
        'test-update-date': item.updatedAt,
      },
    };
  });

export const wrapTablesInOverflowContainer = (html?: string | null): string => {
  if (!html) return '';
  return html
    .replace(/<table\b[^>]*>/gi, '<div class="table-styled">$&')
    .replace(/<\/table>/gi, '</table></div>');
};
